<template>
  <transition name="toast-fade">
    <div v-if="visible" class="toast-container" :class="'toast-' + type" @click="dismiss">
      <span class="toast-icon">
        <font-awesome-icon :icon="iconName" />
      </span>
      <span class="toast-message">{{ message }}</span>
    </div>
  </transition>
</template>

<script>
export default {
  name: "ToastNotification",
  computed: {
    visible() {
      return this.$store.getters["toast/isVisible"];
    },
    message() {
      return this.$store.getters["toast/message"];
    },
    type() {
      return this.$store.getters["toast/type"];
    },
    iconName() {
      switch (this.type) {
        case "warning": return "exclamation-triangle";
        case "error": return "times-circle";
        default: return "info-circle";
      }
    }
  },
  methods: {
    dismiss() {
      this.$store.dispatch("toast/hide");
    }
  }
};
</script>

<style scoped>
.toast-container {
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10001;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  border-radius: 8px;
  font-family: 'Asap', 'Inter', 'Segoe UI', sans-serif;
  font-size: 0.9rem;
  font-weight: 500;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  max-width: 480px;
}

.toast-info {
  background: #1e40af;
  color: #ffffff;
}

.toast-warning {
  background: #fe6565;
  color: #ffffff;
}

.toast-error {
  background: #dc2626;
  color: #ffffff;
}

.toast-icon {
  font-size: 1.1rem;
  flex-shrink: 0;
}

.toast-message {
  line-height: 1.4;
}

.toast-fade-enter-active {
  transition: all 0.2s ease-out;
}

.toast-fade-leave-active {
  transition: all 0.2s ease-in;
}

.toast-fade-enter {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}

.toast-fade-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}
</style>
